/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { forwardRef, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useRouteParam from "../../../../hooks/useRouteParam";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import encryption from "../../../../utils/commonFunctions/encryption";
import axios from "axios";
import { url, port } from "../../../../config/config";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Tooltip,
	IconButton,
	DialogTitle,
	Slide,
	Box
} from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./customGridDialog.css";

import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";
import DoneAllIcon from "@material-ui/icons/DoneAll";
// import ShuffleIcon from "@material-ui/icons/Shuffle";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import CloseIcon from "@material-ui/icons/Close";
import { handleMemberAttributeCellRenderer } from "../../../../utils/commonFunctions/cellRenderers";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { trackPromise } from "react-promise-tracker";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
// const useStyles = (makeStyles) => ({
// 	root: {
// 		margin: 0,
// 		padding: spacing(2)
// 	},
// 	closeButton: {
// 		position: "absolute",
// 		right: spacing(1),
// 		top: spacing(1),
// 		color: grey[500]
// 	}
// });

const previousValueGetter = (params) => {
	if (params.data.field_name === "date_of_birth") {
		return dateTimeZoneConverter(params.data.previous_value);
	} else {
		return params.data.previous_value;
	}
};

const changeValueValueGetter = (params) => {
	if (params.data.field_name === "date_of_birth") {
		return dateTimeZoneConverter(params.data.change_value);
	} else {
		return params.data.change_value;
	}
};

const CustomGridDialog = ({ dialogProps, rowData, handleClose }) => {
	// const classes = useStyles();
	const { openDialog, title, actions, type } = dialogProps;
	const [agGridAPI, setAgGridAPI] = useState(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState(null);
	const agGridRef = useRef(null);
	const navigate = useNavigate();
	const queryGroupNumber = useRouteParam("gn");

	const handleAgGridReady = (params) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleEachMemberDetailsClick = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { member }
		} = row;
		// console.log("Grid Grpu", row.data);
		navigate(`/employer/member?gn=${member.group_number}&&qs=${encryption(member.SSN)}`);
	}, [navigate]);

	const handleApprovePersonalChange = useCallback(async (approvalStatus) => {
		const token = localStorage.getItem("@jwt");
		const baseUrl = `${url}:${port}`;
		const apiUrl = baseUrl + "/api/v1/change-request/approval";
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { _id }
		} = row;
		const payload = [
			{
				_id: _id,
				approval_status: approvalStatus
			}
		];
		const response = await trackPromise(
			axios.patch(apiUrl, payload, {
				headers: { Authorization: `Bearer ${token}` }
			})
		);
		if (response) {
			const status = approvalStatus ? "accepted" : "rejected";
			alert("Succesfully " + status + " personal change");
			window.location.reload();
		}
		// console.log("Response", response);
	}, []);

	const handleAllApproval = useCallback(
		async (approvalStatus) => {
			const payload = [];
			rowData.forEach((eachRowDate) => {
				payload.push({
					_id: eachRowDate._id,
					approval_status: approvalStatus
				});
			});
			const token = localStorage.getItem("@jwt");
			const baseUrl = `${url}:${port}`;
			const apiUrl = baseUrl + "/api/v1/change-request/approval";
			const response = await trackPromise(
				axios.patch(apiUrl, payload, {
					headers: { Authorization: `Bearer ${token}` }
				})
			);
			if (response) {
				const status = approvalStatus ? "accepted" : "rejected";
				alert("Succesfully " + status + " personal change");
				window.location.reload();
			}
		},
		[rowData]
	);

	const handleActionCellRender = useCallback(() => {
		return type !== "enrollment_grid" ? (
			<>
				<Tooltip title="Accept" leaveDelay={200} enterDelay={200} arrow style={{ zIndex: "99999" }}>
					<IconButton onClick={() => handleApprovePersonalChange(true)}>
						<CheckIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Reject" leaveDelay={200} enterDelay={200} arrow>
					<IconButton onClick={() => handleApprovePersonalChange(false)}>
						<ClearIcon />
					</IconButton>
				</Tooltip>
			</>
		) : (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				style={{ marginTop: "3px", marginBottom: "6px" }}
				onClick={handleEachMemberDetailsClick}
			>
				See Details
			</Button>
		);
	}, [handleApprovePersonalChange, handleEachMemberDetailsClick, type]);

	return (
		<div>
			<Dialog
				style={{ zIndex: 5000 }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				className="custom-grid-dialog-container"
			>
				<DialogTitle id="alert-dialog-slide-title">
					<div className="custom-grid-dialog-title">
						<span>{title}</span>
						<span>
							<IconButton aria-label="close" onClick={handleClose}>
								<CloseIcon fontSize="medium" />
							</IconButton>
						</span>
					</div>
				</DialogTitle>
				<DialogContent>
					<div className="dialog-grid-content-container">
						<div className="ag-theme-alpine" style={{ height: "300px", width: "100%" }}>
							{type !== "enrollment_grid" ? (
								<AgGridReact
									ref={agGridRef}
									rowData={rowData}
									onGridReady={handleAgGridReady}
									onFirstDataRendered={handleFirstDataRendered}
									rowSelection={"Single"}
									animateRows
									suppressColumnVirtualisation={true}
									defaultColDef={{
										filter: "agTextColumnFilter",
										floatingFilter: false,
										resizable: true
									}}
									frameworkComponents={{
										handleActionCellRender: handleActionCellRender,
										handleMemberAttributeCellRenderer: handleMemberAttributeCellRenderer
									}}
								>
									<AgGridColumn
										field="field_name"
										headerName="Change Field"
										suppressSizeToFit
										cellRenderer="handleMemberAttributeCellRenderer"
									></AgGridColumn>

									<AgGridColumn
										field="previous_value"
										headerName="Previous Data"
										valueGetter={previousValueGetter}
									></AgGridColumn>
									<AgGridColumn
										valueGetter={changeValueValueGetter}
										field="change_value"
										headerName="New Data"
										suppressSizeToFit={true}
									></AgGridColumn>

									<AgGridColumn
										field="action"
										headerName="Action"
										cellRenderer="handleActionCellRender"
										suppressSizeToFit={true}
									></AgGridColumn>
								</AgGridReact>
							) : (
								<AgGridReact
									ref={agGridRef}
									rowData={rowData}
									onGridReady={handleAgGridReady}
									onFirstDataRendered={handleFirstDataRendered}
									rowSelection={"Single"}
									animateRows
									suppressColumnVirtualisation={true}
									defaultColDef={{
										resizable: true
									}}
									frameworkComponents={{ handleActionCellRender: handleActionCellRender }}
								>
									<AgGridColumn
										field="member.member_id"
										headerName="Employeee Id"
										suppressSizeToFit={true}
									></AgGridColumn>
									<AgGridColumn
										field="member.first_name"
										headerName="First Name"
										suppressSizeToFit={true}
									></AgGridColumn>

									<AgGridColumn field="member.last_name" headerName="Last Name"></AgGridColumn>

									<AgGridColumn field="member.SSN" headerName="SSN"></AgGridColumn>

									<AgGridColumn field="location_name" headerName="Location Name"></AgGridColumn>

									<AgGridColumn
										field="enrollment_status"
										headerName="Enrollment Status"
										suppressSizeToFit={true}
									></AgGridColumn>
									<AgGridColumn
										field="action"
										headerName="See Details"
										cellRenderer="handleActionCellRender"
										suppressSizeToFit={true}
									></AgGridColumn>
								</AgGridReact>
							)}
						</div>
					</div>
				</DialogContent>
				<DialogActions className="custom-dialog-actions-button-container">
					{actions.map((action, index) => {
						const { label, name, callback } = action;
						return (
							<Button
								className={
									name === "accept_all"
										? "custom-dialog-action-button-green"
										: "custom-dialog-action-button-red"
								}
								variant="contained"
								key={index}
								onClick={
									name === "accept_all"
										? () => handleAllApproval(true)
										: name === "reject_all"
											? () => handleAllApproval(false)
											: callback
								}
							>
								<span className="custom-dialog-action-button-label-with-icon">{label}</span>
								<span>
									{name === "accept_all" ? (
										<DoneAllIcon className="custom-dialog-action-button-icon" />
									) : (
										<CloseIcon className="custom-dialog-action-button-icon" />
									)}
								</span>
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default CustomGridDialog;
